import React, { useEffect, useState } from "react";
import * as func from "../../common/athleteCommon/FunctionCalls";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CompetitionPerformance = () => {

    const [compPerformanceList, setCompPerformanceList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchCompetitionPerformance() {
            setIsLoading(true);
            const compPerformanceResponse = await func.competitionPerformance(null);
            setCompPerformanceList(Array.isArray(compPerformanceResponse) ? compPerformanceResponse : [])
            setIsLoading(false);
        }
        fetchCompetitionPerformance();
    }, [])

    const filteredData = compPerformanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.sportsName}</span>
    };

    const sportCtgryNameRender = (rowData) => {
        return <span>{rowData.sportcategoryName}</span>
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>
    };

    const athletePerfrmanceRender = (rowData) => {
        return <span>{rowData.athleteperformancestat}</span>
    };

    const athleteRankRender = (rowData) => {
        return <span>{rowData.athleterank}</span>
    };

    const totalParticipantsRender = (rowData) => {
        return <span>{rowData.competitorscount}</span>
    };

    const genderRender = (rowData) => {
        return <span>{rowData.genderName}</span>
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competition Performance</h4>
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="Athlet"
                                                header="Athlete"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="genderName"
                                                header="Gender"
                                                body={genderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionName"
                                                header="Event"
                                                body={compNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportcategoryName"
                                                header="Sport Category"
                                                body={sportCtgryNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportName"
                                                header="Sport"
                                                body={sportNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="remarks"
                                                header="Remarks"
                                                body={remarksRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athletePerformanceStatistic"
                                                header="Athlet Performance"
                                                body={athletePerfrmanceRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteRank"
                                                header="Athlet Rank"
                                                body={athleteRankRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="totalParticipants"
                                                header="Total Participants"
                                                body={totalParticipantsRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompetitionPerformance;